<form [formGroup]="formGroup" class="form form-container">
  <div class="form adress-block">
    <formly-form
      [model]="healthAssureFormModel"
      [fields]="fieldsAdresse"
      [form]="formGroup"
    ></formly-form>
  </div>

  <mat-form-field>
    <wz-date-input
      formControlName="dateNaissance"
      placeholder="Date de naissance"
    ></wz-date-input>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('majorPerson')"
      wzI18n="FORMS_BIRTHDAY_MAJORPERSON"
    ></mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('required')"
      wzI18n="FORMS_BIRTHDAY_REQUIRED"
    ></mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('max')"
      wzI18n="FORMS_BIRTHDAY_MIN"
      [wzI18nParams]="minAge"
    >
    </mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('min')"
      wzI18n="FORMS_BIRTHDAY_MAX"
      [wzI18nParams]="maxAge"
    >
    </mat-error>
    <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
  </mat-form-field>

  <mat-form-field>
    <wz-date-input
      formControlName="dateEffet"
      placeholder="Date d'effet"
    ></wz-date-input>
    <mat-error *ngIf="dateEffectCtrl.hasError('required')"
      >La date d'effet est obligatoire.</mat-error
    >
    <mat-error *ngIf="dateEffectCtrl.hasError('min')"
      >La date d'effet doit être égale ou postérieure à
      {{ healthEffectDateMin | date }}
    </mat-error>
    <mat-error *ngIf="dateEffectCtrl.hasError('max')"
      >La date d'effet ne peut pas être supérieur à an.
    </mat-error>
    <mat-hint>
      <span wzI18n="FORMS_DATE_HINT"></span>
    </mat-hint>
  </mat-form-field>

  <wz-button-toggle
    title="Régime social *"
    enumItemsKey="REGIME_SOCIAL_ENUM"
    formControlName="regimeSocial"
    [fullWidth]="true"
    orientation="row"
  >
  </wz-button-toggle>
  <mat-error
    *ngIf="regimeSocialCtrl.dirty && regimeSocialCtrl.hasError('required')"
    >Le régime social doit être renseigné
  </mat-error>
</form>
